'use client'
import React, { useState } from 'react'
import { cn } from '../../helpers/utils.js'
// import 'swiper/css'
// import 'swiper/css/free-mode'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, FreeMode, Mousewheel } from 'swiper/modules'
import type { SwiperBoxProps } from './types.js'

const SwiperBox = React.forwardRef<HTMLDivElement, SwiperBoxProps>(
  ({ data, breakpoints, Slide, className, id, itemClassName, ...rest }, ref) => {
    const [isStart, setStart] = useState(true)
    const [isEnd, setEnd] = useState(false)

    return (
      <div {...rest} ref={ref}>
        <Swiper
          className={cn(className)}
          navigation={{
            nextEl: `.${id}-custom-swiper-button-next`,
            prevEl: `.${id}-custom-swiper-button-prev`,
          }}
          onProgress={swiper => {
            setStart(swiper.isBeginning)
            setEnd(swiper.isEnd)
          }}
          modules={[Navigation, FreeMode, Mousewheel]}
          freeMode={true}
          mousewheel={{
            forceToAxis: true,
          }}
          breakpoints={
            breakpoints || {
              0: {
                spaceBetween: 12,
                slidesPerView: 1,
                freeMode: false,
              },
              374: {
                spaceBetween: 12,
                slidesPerView: 1.2,
                freeMode: false,
              },
              768: {
                spaceBetween: 16,
                slidesPerView: 2,
                freeMode: false,
              },
            }
          }
        >
          {data?.list?.map((item, jIndex) => (
            <SwiperSlide key={id + 'SwiperSlide' + jIndex} className={cn('!flex !h-[unset]', itemClassName)}>
              <Slide
                data={item}
                configuration={data?.configuration ? { ...data?.configuration, index: jIndex } : { index: jIndex }}
                jIndex={jIndex}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    )
  }
)

SwiperBox.displayName = 'SwiperBox'

export default SwiperBox
